import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../ThemeContext';
import CrownIcon from '../assets/Crown.svg';

function TrialExpiryNotice({ subscriptionPackage }) {
  const { mode } = useThemeMode();
  const navigate = useNavigate();

  // Don't render if no subscription package or remaining days > 7
  if (!subscriptionPackage || subscriptionPackage.remaining_days > 7) {
    return null;
  }

  const handleUpgradeClick = () => {
    navigate('/subscription');
  };

  const formatEndDate = (endDate) => {
    return new Date(endDate).toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const getTrialMessage = () => {
    const endDate = formatEndDate(subscriptionPackage.end_date);
    
    // Check if it's a paid plan (amount_paid > 0)
    if (subscriptionPackage.amount_paid && subscriptionPackage.amount_paid > 0) {
      return `You're enjoying ${subscriptionPackage.plan_name} — it will end on ${endDate}.`;
    } else {
      // Trial plan message
      return `You're enjoying a 7-day Free Trial that gives you full access to all features — it will end on ${endDate}.`;
    }
  };

  return (
    <div style={{
      backgroundColor: mode === 'dark' ? '#1a0000' : '#fff5f5',
      border: '1px solid #ff4444',
      borderRadius: '8px',
      padding: '12px 16px',
      marginBottom: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 8px rgba(255, 68, 68, 0.2)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          background: '#26C3C0',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}>
          <img 
            src={CrownIcon} 
            alt="Crown" 
            style={{ 
              width: '20px', 
              height: '20px',
              filter: 'brightness(0) invert(1)'
            }} 
          />
        </div>
        <span style={{
          color: mode === 'dark' ? '#ffffff' : '#d32f2f',
          fontSize: '14px',
          fontFamily: 'Urbanist, Arial, sans-serif',
          lineHeight: '1.4'
        }}>
          {getTrialMessage()}
        </span>
      </div>
      <button
        onClick={handleUpgradeClick}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#26C3C0',
          fontSize: '14px',
          fontFamily: 'Urbanist, Arial, sans-serif',
          fontWeight: '500',
          cursor: 'pointer',
          textDecoration: 'underline',
          padding: '4px 8px'
        }}
      >
        Upgrade Now
      </button>
    </div>
  );
}

export default TrialExpiryNotice;
